import { useTranslation } from '../../i18n/LanguageProvider';
import { projectTranslationsPt } from '../projects/projectsTranslations';
import { supervisions, supervisionLevels, projectTeams, projectsOfStudent } from './studentsData';

const EMAIL = 'frederico.schardong@ufsc.br';
const PROJECT_LABELS = { 'GIAAI-3': 'GIAAI', idrc: 'IdRC' };

export default function Students() {
  const { isPortuguese, t } = useTranslation();
  const text = (pt, en) => isPortuguese ? pt : en;
  const projectTitle = project => isPortuguese
    ? projectTranslationsPt[project.id]?.title || project.title
    : project.title;
  const projectLabel = project => PROJECT_LABELS[project.id] || projectTitle(project);
  const levelLabel = level => level === 'master' ? t('students.master') : t('students.undergraduate');

  return (
    <section className="students-page">
      <h1 className="page-title">{t('nav.students')}</h1>

      <aside className="student-callout">
        <h2>{t('students.prospective')}</h2>
        <p>
          {text(
            <>Se você é estudante de graduação da UFSC e procura orientação de TCC, comece pelo <a href="/students/ufsc">guia para futuros alunos</a>: ele explica como escolher um problema de pesquisa e o que esperar da orientação. Para mestrado, doutorado ou outras oportunidades, <a href={`mailto:${EMAIL}`}>escreva para {EMAIL}</a>.</>,
            <>If you are an undergraduate student at UFSC looking for a thesis advisor, start with the <a href="/students/ufsc">guide for prospective students</a>: it covers how to choose a research problem and what to expect from supervision. For master's, doctoral or other opportunities, <a href={`mailto:${EMAIL}`}>write to {EMAIL}</a>.</>
          )}
        </p>
      </aside>

      <section className="student-section" aria-labelledby="student-supervisions">
        <h2 id="student-supervisions" className="student-section-heading">{text('Orientações', 'Supervision')}</h2>
        <div className="student-blocks student-blocks-supervisions">
          {supervisionLevels.map(level => (
            <article key={level} className="student-block" data-level={level}>
              <h3 className="student-block-heading">
                <span className="student-block-label">{levelLabel(level)}</span>
                <span className="student-block-count">{supervisions.filter(item => item.level === level).length}</span>
              </h3>
              <ul className="student-list student-supervision-list">
                {supervisions.filter(item => item.level === level).map(student => {
                  const projects = projectsOfStudent(student.lattes);
                  return (
                    <li key={`${level}-${student.lattes}`} className="student-supervision">
                      <div className="student-identity">
                        <a className="student-name" href={student.lattes} target="_blank" rel="noreferrer">{student.name}</a>
                        {student.mainSupervisor && (
                          <span className="student-note">{t('students.mainSupervisor')}: {student.mainSupervisor}</span>
                        )}
                        {projects.length > 0 && (
                          <span className="student-projects">
                            {projects.map(project => (
                              <a key={project.id} href={`/projects#${project.id}`}>{projectLabel(project)}</a>
                            ))}
                          </span>
                        )}
                      </div>
                      {student.work && (
                        <div className="student-work">
                          <p className="student-work-title">{student.work.title}</p>
                          <div className="student-work-links">
                            <span className="student-work-year">{student.work.year}</span>
                            {student.work.url && (
                              <a href={student.work.url} target="_blank" rel="noreferrer" aria-label={text(`Registro de ${student.work.title}`, `Repository record for ${student.work.title}`)}>
                                {text('Repositório', 'Repository')} <span aria-hidden="true">↗</span>
                              </a>
                            )}
                            <a
                              className="student-work-pdf"
                              href={student.work.pdfUrl}
                              target="_blank"
                              rel="noreferrer"
                              aria-label={text(`PDF de ${student.work.title}`, `PDF of ${student.work.title}`)}
                            >
                              <svg aria-hidden="true" viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M8 2v8m-3-3 3 3 3-3M3 11v3h10v-3" />
                              </svg>
                              PDF
                            </a>
                          </div>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section className="student-section" aria-labelledby="student-projects">
        <h2 id="student-projects" className="student-section-heading">{t('students.researchProjects')}</h2>
        <div className="student-blocks">
          {projectTeams.map(project => (
            <article key={project.id} className="student-block" data-level="project">
              <h3 className="student-block-heading">
                <a className="student-block-label" href={`/projects#${project.id}`}>{projectLabel(project)}</a>
                <span className="student-block-count">{project.advisedStudents.length}</span>
              </h3>
              <ul className="student-list">
                {project.advisedStudents.map(student => (
                  <li key={student.url}>
                    <a className="student-name" href={student.url} target="_blank" rel="noreferrer">{student.name}</a>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>
    </section>
  );
}
